// @generated by protobuf-ts 2.9.1 with parameter generate_dependencies
// @generated from protobuf file "warrior.proto" (package "proto", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { CustomRotation } from "./common";
/**
 * @generated from protobuf message proto.WarriorTalents
 */
export interface WarriorTalents {
    /**
     * Arms
     *
     * @generated from protobuf field: int32 improved_heroic_strike = 1;
     */
    improvedHeroicStrike: number;
    /**
     * @generated from protobuf field: int32 deflection = 2;
     */
    deflection: number;
    /**
     * @generated from protobuf field: int32 improved_rend = 3;
     */
    improvedRend: number;
    /**
     * @generated from protobuf field: int32 improved_charge = 4;
     */
    improvedCharge: number;
    /**
     * @generated from protobuf field: int32 iron_will = 5;
     */
    ironWill: number;
    /**
     * @generated from protobuf field: int32 tactical_mastery = 6;
     */
    tacticalMastery: number;
    /**
     * @generated from protobuf field: int32 improved_overpower = 7;
     */
    improvedOverpower: number;
    /**
     * @generated from protobuf field: bool anger_management = 8;
     */
    angerManagement: boolean;
    /**
     * @generated from protobuf field: int32 impale = 9;
     */
    impale: number;
    /**
     * @generated from protobuf field: int32 deep_wounds = 10;
     */
    deepWounds: number;
    /**
     * @generated from protobuf field: int32 two_handed_weapon_specialization = 11;
     */
    twoHandedWeaponSpecialization: number;
    /**
     * @generated from protobuf field: int32 taste_for_blood = 12;
     */
    tasteForBlood: number;
    /**
     * @generated from protobuf field: int32 poleaxe_specialization = 13;
     */
    poleaxeSpecialization: number;
    /**
     * @generated from protobuf field: bool sweeping_strikes = 14;
     */
    sweepingStrikes: boolean;
    /**
     * @generated from protobuf field: int32 mace_specialization = 15;
     */
    maceSpecialization: number;
    /**
     * @generated from protobuf field: int32 sword_specialization = 16;
     */
    swordSpecialization: number;
    /**
     * @generated from protobuf field: int32 weapon_mastery = 17;
     */
    weaponMastery: number;
    /**
     * @generated from protobuf field: int32 improved_hamstring = 18;
     */
    improvedHamstring: number;
    /**
     * @generated from protobuf field: int32 trauma = 19;
     */
    trauma: number;
    /**
     * @generated from protobuf field: int32 second_wind = 20;
     */
    secondWind: number;
    /**
     * @generated from protobuf field: bool mortal_strike = 21;
     */
    mortalStrike: boolean;
    /**
     * @generated from protobuf field: int32 strength_of_arms = 22;
     */
    strengthOfArms: number;
    /**
     * @generated from protobuf field: int32 improved_slam = 23;
     */
    improvedSlam: number;
    /**
     * @generated from protobuf field: bool juggernaut = 24;
     */
    juggernaut: boolean;
    /**
     * @generated from protobuf field: int32 improved_mortal_strike = 25;
     */
    improvedMortalStrike: number;
    /**
     * @generated from protobuf field: int32 unrelenting_assault = 26;
     */
    unrelentingAssault: number;
    /**
     * @generated from protobuf field: int32 sudden_death = 27;
     */
    suddenDeath: number;
    /**
     * @generated from protobuf field: bool endless_rage = 28;
     */
    endlessRage: boolean;
    /**
     * @generated from protobuf field: int32 blood_frenzy = 29;
     */
    bloodFrenzy: number;
    /**
     * @generated from protobuf field: int32 wrecking_crew = 30;
     */
    wreckingCrew: number;
    /**
     * @generated from protobuf field: bool bladestorm = 31;
     */
    bladestorm: boolean;
    /**
     * Fury
     *
     * @generated from protobuf field: int32 armored_to_the_teeth = 32;
     */
    armoredToTheTeeth: number;
    /**
     * @generated from protobuf field: int32 booming_voice = 33;
     */
    boomingVoice: number;
    /**
     * @generated from protobuf field: int32 cruelty = 34;
     */
    cruelty: number;
    /**
     * @generated from protobuf field: int32 improved_demoralizing_shout = 35;
     */
    improvedDemoralizingShout: number;
    /**
     * @generated from protobuf field: int32 unbridled_wrath = 36;
     */
    unbridledWrath: number;
    /**
     * @generated from protobuf field: int32 improved_cleave = 37;
     */
    improvedCleave: number;
    /**
     * @generated from protobuf field: bool piercing_howl = 38;
     */
    piercingHowl: boolean;
    /**
     * @generated from protobuf field: int32 blood_craze = 39;
     */
    bloodCraze: number;
    /**
     * @generated from protobuf field: int32 commanding_presence = 40;
     */
    commandingPresence: number;
    /**
     * @generated from protobuf field: int32 dual_wield_specialization = 41;
     */
    dualWieldSpecialization: number;
    /**
     * @generated from protobuf field: int32 improved_execute = 42;
     */
    improvedExecute: number;
    /**
     * @generated from protobuf field: int32 enrage = 43;
     */
    enrage: number;
    /**
     * @generated from protobuf field: int32 precision = 44;
     */
    precision: number;
    /**
     * @generated from protobuf field: bool death_wish = 45;
     */
    deathWish: boolean;
    /**
     * @generated from protobuf field: int32 improved_intercept = 46;
     */
    improvedIntercept: number;
    /**
     * @generated from protobuf field: int32 improved_berserker_rage = 47;
     */
    improvedBerserkerRage: number;
    /**
     * @generated from protobuf field: int32 flurry = 48;
     */
    flurry: number;
    /**
     * @generated from protobuf field: int32 intensify_rage = 49;
     */
    intensifyRage: number;
    /**
     * @generated from protobuf field: bool bloodthirst = 50;
     */
    bloodthirst: boolean;
    /**
     * @generated from protobuf field: int32 improved_whirlwind = 51;
     */
    improvedWhirlwind: number;
    /**
     * @generated from protobuf field: int32 furious_attacks = 52;
     */
    furiousAttacks: number;
    /**
     * @generated from protobuf field: int32 improved_berserker_stance = 53;
     */
    improvedBerserkerStance: number;
    /**
     * @generated from protobuf field: bool heroic_fury = 54;
     */
    heroicFury: boolean;
    /**
     * @generated from protobuf field: bool rampage = 55;
     */
    rampage: boolean;
    /**
     * @generated from protobuf field: int32 bloodsurge = 56;
     */
    bloodsurge: number;
    /**
     * @generated from protobuf field: int32 unending_fury = 57;
     */
    unendingFury: number;
    /**
     * @generated from protobuf field: bool titans_grip = 58;
     */
    titansGrip: boolean;
    /**
     * Protection
     *
     * @generated from protobuf field: int32 improved_bloodrage = 59;
     */
    improvedBloodrage: number;
    /**
     * @generated from protobuf field: int32 shield_specialization = 60;
     */
    shieldSpecialization: number;
    /**
     * @generated from protobuf field: int32 improved_thunder_clap = 61;
     */
    improvedThunderClap: number;
    /**
     * @generated from protobuf field: int32 incite = 62;
     */
    incite: number;
    /**
     * @generated from protobuf field: int32 anticipation = 63;
     */
    anticipation: number;
    /**
     * @generated from protobuf field: bool last_stand = 64;
     */
    lastStand: boolean;
    /**
     * @generated from protobuf field: int32 improved_revenge = 65;
     */
    improvedRevenge: number;
    /**
     * @generated from protobuf field: int32 shield_mastery = 66;
     */
    shieldMastery: number;
    /**
     * @generated from protobuf field: int32 toughness = 67;
     */
    toughness: number;
    /**
     * @generated from protobuf field: int32 improved_spell_reflection = 68;
     */
    improvedSpellReflection: number;
    /**
     * @generated from protobuf field: int32 improved_disarm = 69;
     */
    improvedDisarm: number;
    /**
     * @generated from protobuf field: int32 puncture = 70;
     */
    puncture: number;
    /**
     * @generated from protobuf field: int32 improved_disciplines = 71;
     */
    improvedDisciplines: number;
    /**
     * @generated from protobuf field: bool concussion_blow = 72;
     */
    concussionBlow: boolean;
    /**
     * @generated from protobuf field: int32 gag_order = 73;
     */
    gagOrder: number;
    /**
     * @generated from protobuf field: int32 one_handed_weapon_specialization = 74;
     */
    oneHandedWeaponSpecialization: number;
    /**
     * @generated from protobuf field: int32 improved_defensive_stance = 75;
     */
    improvedDefensiveStance: number;
    /**
     * @generated from protobuf field: bool vigilance = 76;
     */
    vigilance: boolean;
    /**
     * @generated from protobuf field: int32 focused_rage = 77;
     */
    focusedRage: number;
    /**
     * @generated from protobuf field: int32 vitality = 78;
     */
    vitality: number;
    /**
     * @generated from protobuf field: int32 safeguard = 79;
     */
    safeguard: number;
    /**
     * @generated from protobuf field: bool warbringer = 80;
     */
    warbringer: boolean;
    /**
     * @generated from protobuf field: bool devastate = 81;
     */
    devastate: boolean;
    /**
     * @generated from protobuf field: int32 critical_block = 82;
     */
    criticalBlock: number;
    /**
     * @generated from protobuf field: int32 sword_and_board = 83;
     */
    swordAndBoard: number;
    /**
     * @generated from protobuf field: int32 damage_shield = 84;
     */
    damageShield: number;
    /**
     * @generated from protobuf field: bool shockwave = 85;
     */
    shockwave: boolean;
}
/**
 * @generated from protobuf message proto.Warrior
 */
export interface Warrior {
    /**
     * @generated from protobuf field: proto.Warrior.Rotation rotation = 1;
     */
    rotation?: Warrior_Rotation;
    /**
     * @generated from protobuf field: proto.Warrior.Options options = 3;
     */
    options?: Warrior_Options;
}
/**
 * @generated from protobuf message proto.Warrior.Rotation
 */
export interface Warrior_Rotation {
    /**
     * @generated from protobuf field: bool use_cleave = 1;
     */
    useCleave: boolean;
    /**
     * @generated from protobuf field: bool use_rend = 2;
     */
    useRend: boolean;
    /**
     * @generated from protobuf field: bool use_ms = 18;
     */
    useMs: boolean;
    /**
     * @generated from protobuf field: bool use_slam = 3;
     */
    useSlam: boolean;
    /**
     * @generated from protobuf field: proto.Warrior.Rotation.MainGcd main_gcd = 4;
     */
    mainGcd: Warrior_Rotation_MainGcd;
    /**
     * @generated from protobuf field: proto.Warrior.Rotation.SunderArmor sunderArmor = 5;
     */
    sunderArmor: Warrior_Rotation_SunderArmor;
    /**
     * @generated from protobuf field: bool maintain_demo_shout = 6;
     */
    maintainDemoShout: boolean;
    /**
     * @generated from protobuf field: bool maintain_thunder_clap = 7;
     */
    maintainThunderClap: boolean;
    /**
     * Queue HS or Cleave when over this threshold.
     *
     * @generated from protobuf field: double hs_rage_threshold = 8;
     */
    hsRageThreshold: number;
    /**
     * Use Mortal Strike when over this threshold.
     *
     * @generated from protobuf field: double ms_rage_threshold = 9;
     */
    msRageThreshold: number;
    /**
     * Use Rend when below this threshold.
     *
     * @generated from protobuf field: double rend_rage_threshold_below = 10;
     */
    rendRageThresholdBelow: number;
    /**
     * Use Slam when over this threshold.
     *
     * @generated from protobuf field: double slam_rage_threshold = 11;
     */
    slamRageThreshold: number;
    /**
     * Refresh Rend when remaining duration is less than this threshold.
     *
     * @generated from protobuf field: double rend_cd_threshold = 12;
     */
    rendCdThreshold: number;
    /**
     * @generated from protobuf field: bool use_hs_during_execute = 13;
     */
    useHsDuringExecute: boolean;
    /**
     * @generated from protobuf field: bool use_bt_during_execute = 14;
     */
    useBtDuringExecute: boolean;
    /**
     * @generated from protobuf field: bool spam_execute = 15;
     */
    spamExecute: boolean;
    /**
     * @generated from protobuf field: bool use_ww_during_execute = 16;
     */
    useWwDuringExecute: boolean;
    /**
     * @generated from protobuf field: bool use_slam_over_execute = 17;
     */
    useSlamOverExecute: boolean;
    /**
     * @generated from protobuf field: proto.Warrior.Rotation.StanceOption stance_option = 19;
     */
    stanceOption: Warrior_Rotation_StanceOption;
    /**
     * @generated from protobuf field: double rend_health_threshold_above = 20;
     */
    rendHealthThresholdAbove: number;
    /**
     * Only used for Fury
     *
     * @generated from protobuf field: bool use_overpower = 21;
     */
    useOverpower: boolean;
    /**
     * @generated from protobuf field: bool execute_phase_overpower = 22;
     */
    executePhaseOverpower: boolean;
    /**
     * @generated from protobuf field: double bloodsurge_duration_threshold = 25;
     */
    bloodsurgeDurationThreshold: number;
    /**
     * @generated from protobuf field: proto.CustomRotation custom_rotation = 23;
     */
    customRotation?: CustomRotation;
    /**
     * @generated from protobuf field: bool custom_rotation_option = 24;
     */
    customRotationOption: boolean;
}
/**
 * @generated from protobuf enum proto.Warrior.Rotation.MainGcd
 */
export enum Warrior_Rotation_MainGcd {
    /**
     * @generated from protobuf enum value: None = 0;
     */
    None = 0,
    /**
     * @generated from protobuf enum value: Slam = 1;
     */
    Slam = 1,
    /**
     * @generated from protobuf enum value: Bloodthirst = 2;
     */
    Bloodthirst = 2,
    /**
     * @generated from protobuf enum value: Whirlwind = 3;
     */
    Whirlwind = 3
}
/**
 * @generated from protobuf enum proto.Warrior.Rotation.SunderArmor
 */
export enum Warrior_Rotation_SunderArmor {
    /**
     * @generated from protobuf enum value: SunderArmorNone = 0;
     */
    SunderArmorNone = 0,
    /**
     * @generated from protobuf enum value: SunderArmorHelpStack = 1;
     */
    SunderArmorHelpStack = 1,
    /**
     * @generated from protobuf enum value: SunderArmorMaintain = 2;
     */
    SunderArmorMaintain = 2
}
/**
 * @generated from protobuf enum proto.Warrior.Rotation.StanceOption
 */
export enum Warrior_Rotation_StanceOption {
    /**
     * @generated from protobuf enum value: DefaultStance = 0;
     */
    DefaultStance = 0,
    /**
     * @generated from protobuf enum value: BattleStance = 1;
     */
    BattleStance = 1,
    /**
     * @generated from protobuf enum value: BerserkerStance = 2;
     */
    BerserkerStance = 2
}
/**
 * @generated from protobuf enum proto.Warrior.Rotation.SpellOption
 */
export enum Warrior_Rotation_SpellOption {
    /**
     * @generated from protobuf enum value: NoSpell = 0;
     */
    NoSpell = 0,
    /**
     * @generated from protobuf enum value: BloodthirstCustom = 1;
     */
    BloodthirstCustom = 1,
    /**
     * @generated from protobuf enum value: MortalStrike = 2;
     */
    MortalStrike = 2,
    /**
     * @generated from protobuf enum value: WhirlwindCustom = 3;
     */
    WhirlwindCustom = 3,
    /**
     * @generated from protobuf enum value: SlamCustom = 4;
     */
    SlamCustom = 4,
    /**
     * @generated from protobuf enum value: Rend = 5;
     */
    Rend = 5,
    /**
     * @generated from protobuf enum value: Overpower = 6;
     */
    Overpower = 6,
    /**
     * @generated from protobuf enum value: Execute = 7;
     */
    Execute = 7,
    /**
     * @generated from protobuf enum value: ThunderClap = 8;
     */
    ThunderClap = 8,
    /**
     * @generated from protobuf enum value: SlamExpiring = 9;
     */
    SlamExpiring = 9
}
/**
 * @generated from protobuf message proto.Warrior.Options
 */
export interface Warrior_Options {
    /**
     * @generated from protobuf field: double starting_rage = 1;
     */
    startingRage: number;
    /**
     * @generated from protobuf field: bool use_recklessness = 2;
     */
    useRecklessness: boolean;
    /**
     * @generated from protobuf field: bool use_shattering_throw = 4;
     */
    useShatteringThrow: boolean;
    /**
     * @generated from protobuf field: proto.WarriorShout shout = 3;
     */
    shout: WarriorShout;
    /**
     * @generated from protobuf field: bool munch = 5;
     */
    munch: boolean;
    /**
     * @generated from protobuf field: bool stance_snapshot = 6;
     */
    stanceSnapshot: boolean;
}
/**
 * @generated from protobuf message proto.ProtectionWarrior
 */
export interface ProtectionWarrior {
    /**
     * @generated from protobuf field: proto.ProtectionWarrior.Rotation rotation = 1;
     */
    rotation?: ProtectionWarrior_Rotation;
    /**
     * @generated from protobuf field: proto.ProtectionWarrior.Options options = 3;
     */
    options?: ProtectionWarrior_Options;
}
/**
 * @generated from protobuf message proto.ProtectionWarrior.Rotation
 */
export interface ProtectionWarrior_Rotation {
    /**
     * @generated from protobuf field: proto.ProtectionWarrior.Rotation.DemoShoutChoice demo_shout_choice = 1;
     */
    demoShoutChoice: ProtectionWarrior_Rotation_DemoShoutChoice;
    /**
     * @generated from protobuf field: proto.ProtectionWarrior.Rotation.ThunderClapChoice thunder_clap_choice = 2;
     */
    thunderClapChoice: ProtectionWarrior_Rotation_ThunderClapChoice;
    /**
     * @generated from protobuf field: proto.CustomRotation custom_rotation = 3;
     */
    customRotation?: CustomRotation;
    /**
     * @generated from protobuf field: double hs_rage_threshold = 4;
     */
    hsRageThreshold: number;
    /**
     * @generated from protobuf field: bool prio_sslam_on_shield_block = 5;
     */
    prioSslamOnShieldBlock: boolean;
}
/**
 * @generated from protobuf enum proto.ProtectionWarrior.Rotation.DemoShoutChoice
 */
export enum ProtectionWarrior_Rotation_DemoShoutChoice {
    /**
     * @generated from protobuf enum value: DemoShoutChoiceNone = 0;
     */
    DemoShoutChoiceNone = 0,
    /**
     * @generated from protobuf enum value: DemoShoutChoiceMaintain = 1;
     */
    DemoShoutChoiceMaintain = 1,
    /**
     * @generated from protobuf enum value: DemoShoutChoiceFiller = 2;
     */
    DemoShoutChoiceFiller = 2
}
/**
 * @generated from protobuf enum proto.ProtectionWarrior.Rotation.ThunderClapChoice
 */
export enum ProtectionWarrior_Rotation_ThunderClapChoice {
    /**
     * @generated from protobuf enum value: ThunderClapChoiceNone = 0;
     */
    ThunderClapChoiceNone = 0,
    /**
     * @generated from protobuf enum value: ThunderClapChoiceMaintain = 1;
     */
    ThunderClapChoiceMaintain = 1,
    /**
     * @generated from protobuf enum value: ThunderClapChoiceOnCD = 2;
     */
    ThunderClapChoiceOnCD = 2
}
/**
 * @generated from protobuf enum proto.ProtectionWarrior.Rotation.SpellOption
 */
export enum ProtectionWarrior_Rotation_SpellOption {
    /**
     * @generated from protobuf enum value: NoSpell = 0;
     */
    NoSpell = 0,
    /**
     * @generated from protobuf enum value: Revenge = 1;
     */
    Revenge = 1,
    /**
     * @generated from protobuf enum value: ShieldSlam = 2;
     */
    ShieldSlam = 2,
    /**
     * @generated from protobuf enum value: Devastate = 3;
     */
    Devastate = 3,
    /**
     * @generated from protobuf enum value: SunderArmor = 4;
     */
    SunderArmor = 4,
    /**
     * @generated from protobuf enum value: Shout = 5;
     */
    Shout = 5,
    /**
     * @generated from protobuf enum value: DemoralizingShout = 6;
     */
    DemoralizingShout = 6,
    /**
     * @generated from protobuf enum value: ThunderClap = 7;
     */
    ThunderClap = 7,
    /**
     * @generated from protobuf enum value: MortalStrike = 8;
     */
    MortalStrike = 8,
    /**
     * @generated from protobuf enum value: ConcussionBlow = 9;
     */
    ConcussionBlow = 9,
    /**
     * @generated from protobuf enum value: Shockwave = 10;
     */
    Shockwave = 10
}
/**
 * @generated from protobuf message proto.ProtectionWarrior.Options
 */
export interface ProtectionWarrior_Options {
    /**
     * @generated from protobuf field: double starting_rage = 1;
     */
    startingRage: number;
    /**
     * @generated from protobuf field: proto.WarriorShout shout = 4;
     */
    shout: WarriorShout;
    /**
     * @generated from protobuf field: bool use_shattering_throw = 8;
     */
    useShatteringThrow: boolean;
    /**
     * @generated from protobuf field: bool munch = 9;
     */
    munch: boolean;
}
/**
 * @generated from protobuf enum proto.WarriorMajorGlyph
 */
export enum WarriorMajorGlyph {
    /**
     * @generated from protobuf enum value: WarriorMajorGlyphNone = 0;
     */
    WarriorMajorGlyphNone = 0,
    /**
     * @generated from protobuf enum value: GlyphOfBarbaricInsults = 43420;
     */
    GlyphOfBarbaricInsults = 43420,
    /**
     * @generated from protobuf enum value: GlyphOfBladestorm = 45790;
     */
    GlyphOfBladestorm = 45790,
    /**
     * @generated from protobuf enum value: GlyphOfBlocking = 43425;
     */
    GlyphOfBlocking = 43425,
    /**
     * @generated from protobuf enum value: GlyphOfBloodthirst = 43412;
     */
    GlyphOfBloodthirst = 43412,
    /**
     * @generated from protobuf enum value: GlyphOfCleaving = 43414;
     */
    GlyphOfCleaving = 43414,
    /**
     * @generated from protobuf enum value: GlyphOfDevastate = 43415;
     */
    GlyphOfDevastate = 43415,
    /**
     * @generated from protobuf enum value: GlyphOfEnragedRegeneration = 45794;
     */
    GlyphOfEnragedRegeneration = 45794,
    /**
     * @generated from protobuf enum value: GlyphOfExecution = 43416;
     */
    GlyphOfExecution = 43416,
    /**
     * @generated from protobuf enum value: GlyphOfHamstring = 43417;
     */
    GlyphOfHamstring = 43417,
    /**
     * @generated from protobuf enum value: GlyphOfHeroicStrike = 43418;
     */
    GlyphOfHeroicStrike = 43418,
    /**
     * @generated from protobuf enum value: GlyphOfIntervene = 43419;
     */
    GlyphOfIntervene = 43419,
    /**
     * @generated from protobuf enum value: GlyphOfLastStand = 43426;
     */
    GlyphOfLastStand = 43426,
    /**
     * @generated from protobuf enum value: GlyphOfMortalStrike = 43421;
     */
    GlyphOfMortalStrike = 43421,
    /**
     * @generated from protobuf enum value: GlyphOfOverpower = 43422;
     */
    GlyphOfOverpower = 43422,
    /**
     * @generated from protobuf enum value: GlyphOfRapidCharge = 43413;
     */
    GlyphOfRapidCharge = 43413,
    /**
     * @generated from protobuf enum value: GlyphOfRending = 43423;
     */
    GlyphOfRending = 43423,
    /**
     * @generated from protobuf enum value: GlyphOfResonatingPower = 43430;
     */
    GlyphOfResonatingPower = 43430,
    /**
     * @generated from protobuf enum value: GlyphOfRevenge = 43424;
     */
    GlyphOfRevenge = 43424,
    /**
     * @generated from protobuf enum value: GlyphOfShieldWall = 45797;
     */
    GlyphOfShieldWall = 45797,
    /**
     * @generated from protobuf enum value: GlyphOfShockwave = 45792;
     */
    GlyphOfShockwave = 45792,
    /**
     * @generated from protobuf enum value: GlyphOfSpellReflection = 45795;
     */
    GlyphOfSpellReflection = 45795,
    /**
     * @generated from protobuf enum value: GlyphOfSunderArmor = 43427;
     */
    GlyphOfSunderArmor = 43427,
    /**
     * @generated from protobuf enum value: GlyphOfSweepingStrikes = 43428;
     */
    GlyphOfSweepingStrikes = 43428,
    /**
     * @generated from protobuf enum value: GlyphOfTaunt = 43429;
     */
    GlyphOfTaunt = 43429,
    /**
     * @generated from protobuf enum value: GlyphOfVictoryRush = 43431;
     */
    GlyphOfVictoryRush = 43431,
    /**
     * @generated from protobuf enum value: GlyphOfVigilance = 45793;
     */
    GlyphOfVigilance = 45793,
    /**
     * @generated from protobuf enum value: GlyphOfWhirlwind = 43432;
     */
    GlyphOfWhirlwind = 43432
}
/**
 * @generated from protobuf enum proto.WarriorMinorGlyph
 */
export enum WarriorMinorGlyph {
    /**
     * @generated from protobuf enum value: WarriorMinorGlyphNone = 0;
     */
    WarriorMinorGlyphNone = 0,
    /**
     * @generated from protobuf enum value: GlyphOfBattle = 43395;
     */
    GlyphOfBattle = 43395,
    /**
     * @generated from protobuf enum value: GlyphOfBloodrage = 43396;
     */
    GlyphOfBloodrage = 43396,
    /**
     * @generated from protobuf enum value: GlyphOfCharge = 43397;
     */
    GlyphOfCharge = 43397,
    /**
     * @generated from protobuf enum value: GlyphOfCommand = 49084;
     */
    GlyphOfCommand = 49084,
    /**
     * @generated from protobuf enum value: GlyphOfEnduringVictory = 43400;
     */
    GlyphOfEnduringVictory = 43400,
    /**
     * @generated from protobuf enum value: GlyphOfMockingBlow = 43398;
     */
    GlyphOfMockingBlow = 43398,
    /**
     * @generated from protobuf enum value: GlyphOfThunderClap = 43399;
     */
    GlyphOfThunderClap = 43399,
    /**
     * @generated from protobuf enum value: GlyphOfShatteringThrow = 206953;
     */
    GlyphOfShatteringThrow = 206953
}
/**
 * @generated from protobuf enum proto.WarriorShout
 */
export enum WarriorShout {
    /**
     * @generated from protobuf enum value: WarriorShoutNone = 0;
     */
    WarriorShoutNone = 0,
    /**
     * @generated from protobuf enum value: WarriorShoutBattle = 1;
     */
    WarriorShoutBattle = 1,
    /**
     * @generated from protobuf enum value: WarriorShoutCommanding = 2;
     */
    WarriorShoutCommanding = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class WarriorTalents$Type extends MessageType<WarriorTalents> {
    constructor() {
        super("proto.WarriorTalents", [
            { no: 1, name: "improved_heroic_strike", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "deflection", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "improved_rend", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "improved_charge", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "iron_will", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "tactical_mastery", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "improved_overpower", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "anger_management", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "impale", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "deep_wounds", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "two_handed_weapon_specialization", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "taste_for_blood", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "poleaxe_specialization", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "sweeping_strikes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "mace_specialization", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "sword_specialization", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "weapon_mastery", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "improved_hamstring", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "trauma", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "second_wind", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "mortal_strike", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "strength_of_arms", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 23, name: "improved_slam", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 24, name: "juggernaut", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "improved_mortal_strike", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 26, name: "unrelenting_assault", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 27, name: "sudden_death", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 28, name: "endless_rage", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 29, name: "blood_frenzy", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 30, name: "wrecking_crew", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 31, name: "bladestorm", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 32, name: "armored_to_the_teeth", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 33, name: "booming_voice", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 34, name: "cruelty", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 35, name: "improved_demoralizing_shout", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 36, name: "unbridled_wrath", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 37, name: "improved_cleave", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 38, name: "piercing_howl", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 39, name: "blood_craze", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 40, name: "commanding_presence", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 41, name: "dual_wield_specialization", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 42, name: "improved_execute", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 43, name: "enrage", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 44, name: "precision", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 45, name: "death_wish", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 46, name: "improved_intercept", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 47, name: "improved_berserker_rage", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 48, name: "flurry", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 49, name: "intensify_rage", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 50, name: "bloodthirst", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 51, name: "improved_whirlwind", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 52, name: "furious_attacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 53, name: "improved_berserker_stance", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 54, name: "heroic_fury", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 55, name: "rampage", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 56, name: "bloodsurge", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 57, name: "unending_fury", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 58, name: "titans_grip", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 59, name: "improved_bloodrage", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 60, name: "shield_specialization", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 61, name: "improved_thunder_clap", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 62, name: "incite", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 63, name: "anticipation", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 64, name: "last_stand", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 65, name: "improved_revenge", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 66, name: "shield_mastery", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 67, name: "toughness", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 68, name: "improved_spell_reflection", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 69, name: "improved_disarm", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 70, name: "puncture", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 71, name: "improved_disciplines", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 72, name: "concussion_blow", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 73, name: "gag_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 74, name: "one_handed_weapon_specialization", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 75, name: "improved_defensive_stance", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 76, name: "vigilance", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 77, name: "focused_rage", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 78, name: "vitality", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 79, name: "safeguard", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 80, name: "warbringer", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 81, name: "devastate", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 82, name: "critical_block", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 83, name: "sword_and_board", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 84, name: "damage_shield", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 85, name: "shockwave", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<WarriorTalents>): WarriorTalents {
        const message = { improvedHeroicStrike: 0, deflection: 0, improvedRend: 0, improvedCharge: 0, ironWill: 0, tacticalMastery: 0, improvedOverpower: 0, angerManagement: false, impale: 0, deepWounds: 0, twoHandedWeaponSpecialization: 0, tasteForBlood: 0, poleaxeSpecialization: 0, sweepingStrikes: false, maceSpecialization: 0, swordSpecialization: 0, weaponMastery: 0, improvedHamstring: 0, trauma: 0, secondWind: 0, mortalStrike: false, strengthOfArms: 0, improvedSlam: 0, juggernaut: false, improvedMortalStrike: 0, unrelentingAssault: 0, suddenDeath: 0, endlessRage: false, bloodFrenzy: 0, wreckingCrew: 0, bladestorm: false, armoredToTheTeeth: 0, boomingVoice: 0, cruelty: 0, improvedDemoralizingShout: 0, unbridledWrath: 0, improvedCleave: 0, piercingHowl: false, bloodCraze: 0, commandingPresence: 0, dualWieldSpecialization: 0, improvedExecute: 0, enrage: 0, precision: 0, deathWish: false, improvedIntercept: 0, improvedBerserkerRage: 0, flurry: 0, intensifyRage: 0, bloodthirst: false, improvedWhirlwind: 0, furiousAttacks: 0, improvedBerserkerStance: 0, heroicFury: false, rampage: false, bloodsurge: 0, unendingFury: 0, titansGrip: false, improvedBloodrage: 0, shieldSpecialization: 0, improvedThunderClap: 0, incite: 0, anticipation: 0, lastStand: false, improvedRevenge: 0, shieldMastery: 0, toughness: 0, improvedSpellReflection: 0, improvedDisarm: 0, puncture: 0, improvedDisciplines: 0, concussionBlow: false, gagOrder: 0, oneHandedWeaponSpecialization: 0, improvedDefensiveStance: 0, vigilance: false, focusedRage: 0, vitality: 0, safeguard: 0, warbringer: false, devastate: false, criticalBlock: 0, swordAndBoard: 0, damageShield: 0, shockwave: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<WarriorTalents>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WarriorTalents): WarriorTalents {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 improved_heroic_strike */ 1:
                    message.improvedHeroicStrike = reader.int32();
                    break;
                case /* int32 deflection */ 2:
                    message.deflection = reader.int32();
                    break;
                case /* int32 improved_rend */ 3:
                    message.improvedRend = reader.int32();
                    break;
                case /* int32 improved_charge */ 4:
                    message.improvedCharge = reader.int32();
                    break;
                case /* int32 iron_will */ 5:
                    message.ironWill = reader.int32();
                    break;
                case /* int32 tactical_mastery */ 6:
                    message.tacticalMastery = reader.int32();
                    break;
                case /* int32 improved_overpower */ 7:
                    message.improvedOverpower = reader.int32();
                    break;
                case /* bool anger_management */ 8:
                    message.angerManagement = reader.bool();
                    break;
                case /* int32 impale */ 9:
                    message.impale = reader.int32();
                    break;
                case /* int32 deep_wounds */ 10:
                    message.deepWounds = reader.int32();
                    break;
                case /* int32 two_handed_weapon_specialization */ 11:
                    message.twoHandedWeaponSpecialization = reader.int32();
                    break;
                case /* int32 taste_for_blood */ 12:
                    message.tasteForBlood = reader.int32();
                    break;
                case /* int32 poleaxe_specialization */ 13:
                    message.poleaxeSpecialization = reader.int32();
                    break;
                case /* bool sweeping_strikes */ 14:
                    message.sweepingStrikes = reader.bool();
                    break;
                case /* int32 mace_specialization */ 15:
                    message.maceSpecialization = reader.int32();
                    break;
                case /* int32 sword_specialization */ 16:
                    message.swordSpecialization = reader.int32();
                    break;
                case /* int32 weapon_mastery */ 17:
                    message.weaponMastery = reader.int32();
                    break;
                case /* int32 improved_hamstring */ 18:
                    message.improvedHamstring = reader.int32();
                    break;
                case /* int32 trauma */ 19:
                    message.trauma = reader.int32();
                    break;
                case /* int32 second_wind */ 20:
                    message.secondWind = reader.int32();
                    break;
                case /* bool mortal_strike */ 21:
                    message.mortalStrike = reader.bool();
                    break;
                case /* int32 strength_of_arms */ 22:
                    message.strengthOfArms = reader.int32();
                    break;
                case /* int32 improved_slam */ 23:
                    message.improvedSlam = reader.int32();
                    break;
                case /* bool juggernaut */ 24:
                    message.juggernaut = reader.bool();
                    break;
                case /* int32 improved_mortal_strike */ 25:
                    message.improvedMortalStrike = reader.int32();
                    break;
                case /* int32 unrelenting_assault */ 26:
                    message.unrelentingAssault = reader.int32();
                    break;
                case /* int32 sudden_death */ 27:
                    message.suddenDeath = reader.int32();
                    break;
                case /* bool endless_rage */ 28:
                    message.endlessRage = reader.bool();
                    break;
                case /* int32 blood_frenzy */ 29:
                    message.bloodFrenzy = reader.int32();
                    break;
                case /* int32 wrecking_crew */ 30:
                    message.wreckingCrew = reader.int32();
                    break;
                case /* bool bladestorm */ 31:
                    message.bladestorm = reader.bool();
                    break;
                case /* int32 armored_to_the_teeth */ 32:
                    message.armoredToTheTeeth = reader.int32();
                    break;
                case /* int32 booming_voice */ 33:
                    message.boomingVoice = reader.int32();
                    break;
                case /* int32 cruelty */ 34:
                    message.cruelty = reader.int32();
                    break;
                case /* int32 improved_demoralizing_shout */ 35:
                    message.improvedDemoralizingShout = reader.int32();
                    break;
                case /* int32 unbridled_wrath */ 36:
                    message.unbridledWrath = reader.int32();
                    break;
                case /* int32 improved_cleave */ 37:
                    message.improvedCleave = reader.int32();
                    break;
                case /* bool piercing_howl */ 38:
                    message.piercingHowl = reader.bool();
                    break;
                case /* int32 blood_craze */ 39:
                    message.bloodCraze = reader.int32();
                    break;
                case /* int32 commanding_presence */ 40:
                    message.commandingPresence = reader.int32();
                    break;
                case /* int32 dual_wield_specialization */ 41:
                    message.dualWieldSpecialization = reader.int32();
                    break;
                case /* int32 improved_execute */ 42:
                    message.improvedExecute = reader.int32();
                    break;
                case /* int32 enrage */ 43:
                    message.enrage = reader.int32();
                    break;
                case /* int32 precision */ 44:
                    message.precision = reader.int32();
                    break;
                case /* bool death_wish */ 45:
                    message.deathWish = reader.bool();
                    break;
                case /* int32 improved_intercept */ 46:
                    message.improvedIntercept = reader.int32();
                    break;
                case /* int32 improved_berserker_rage */ 47:
                    message.improvedBerserkerRage = reader.int32();
                    break;
                case /* int32 flurry */ 48:
                    message.flurry = reader.int32();
                    break;
                case /* int32 intensify_rage */ 49:
                    message.intensifyRage = reader.int32();
                    break;
                case /* bool bloodthirst */ 50:
                    message.bloodthirst = reader.bool();
                    break;
                case /* int32 improved_whirlwind */ 51:
                    message.improvedWhirlwind = reader.int32();
                    break;
                case /* int32 furious_attacks */ 52:
                    message.furiousAttacks = reader.int32();
                    break;
                case /* int32 improved_berserker_stance */ 53:
                    message.improvedBerserkerStance = reader.int32();
                    break;
                case /* bool heroic_fury */ 54:
                    message.heroicFury = reader.bool();
                    break;
                case /* bool rampage */ 55:
                    message.rampage = reader.bool();
                    break;
                case /* int32 bloodsurge */ 56:
                    message.bloodsurge = reader.int32();
                    break;
                case /* int32 unending_fury */ 57:
                    message.unendingFury = reader.int32();
                    break;
                case /* bool titans_grip */ 58:
                    message.titansGrip = reader.bool();
                    break;
                case /* int32 improved_bloodrage */ 59:
                    message.improvedBloodrage = reader.int32();
                    break;
                case /* int32 shield_specialization */ 60:
                    message.shieldSpecialization = reader.int32();
                    break;
                case /* int32 improved_thunder_clap */ 61:
                    message.improvedThunderClap = reader.int32();
                    break;
                case /* int32 incite */ 62:
                    message.incite = reader.int32();
                    break;
                case /* int32 anticipation */ 63:
                    message.anticipation = reader.int32();
                    break;
                case /* bool last_stand */ 64:
                    message.lastStand = reader.bool();
                    break;
                case /* int32 improved_revenge */ 65:
                    message.improvedRevenge = reader.int32();
                    break;
                case /* int32 shield_mastery */ 66:
                    message.shieldMastery = reader.int32();
                    break;
                case /* int32 toughness */ 67:
                    message.toughness = reader.int32();
                    break;
                case /* int32 improved_spell_reflection */ 68:
                    message.improvedSpellReflection = reader.int32();
                    break;
                case /* int32 improved_disarm */ 69:
                    message.improvedDisarm = reader.int32();
                    break;
                case /* int32 puncture */ 70:
                    message.puncture = reader.int32();
                    break;
                case /* int32 improved_disciplines */ 71:
                    message.improvedDisciplines = reader.int32();
                    break;
                case /* bool concussion_blow */ 72:
                    message.concussionBlow = reader.bool();
                    break;
                case /* int32 gag_order */ 73:
                    message.gagOrder = reader.int32();
                    break;
                case /* int32 one_handed_weapon_specialization */ 74:
                    message.oneHandedWeaponSpecialization = reader.int32();
                    break;
                case /* int32 improved_defensive_stance */ 75:
                    message.improvedDefensiveStance = reader.int32();
                    break;
                case /* bool vigilance */ 76:
                    message.vigilance = reader.bool();
                    break;
                case /* int32 focused_rage */ 77:
                    message.focusedRage = reader.int32();
                    break;
                case /* int32 vitality */ 78:
                    message.vitality = reader.int32();
                    break;
                case /* int32 safeguard */ 79:
                    message.safeguard = reader.int32();
                    break;
                case /* bool warbringer */ 80:
                    message.warbringer = reader.bool();
                    break;
                case /* bool devastate */ 81:
                    message.devastate = reader.bool();
                    break;
                case /* int32 critical_block */ 82:
                    message.criticalBlock = reader.int32();
                    break;
                case /* int32 sword_and_board */ 83:
                    message.swordAndBoard = reader.int32();
                    break;
                case /* int32 damage_shield */ 84:
                    message.damageShield = reader.int32();
                    break;
                case /* bool shockwave */ 85:
                    message.shockwave = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WarriorTalents, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 improved_heroic_strike = 1; */
        if (message.improvedHeroicStrike !== 0)
            writer.tag(1, WireType.Varint).int32(message.improvedHeroicStrike);
        /* int32 deflection = 2; */
        if (message.deflection !== 0)
            writer.tag(2, WireType.Varint).int32(message.deflection);
        /* int32 improved_rend = 3; */
        if (message.improvedRend !== 0)
            writer.tag(3, WireType.Varint).int32(message.improvedRend);
        /* int32 improved_charge = 4; */
        if (message.improvedCharge !== 0)
            writer.tag(4, WireType.Varint).int32(message.improvedCharge);
        /* int32 iron_will = 5; */
        if (message.ironWill !== 0)
            writer.tag(5, WireType.Varint).int32(message.ironWill);
        /* int32 tactical_mastery = 6; */
        if (message.tacticalMastery !== 0)
            writer.tag(6, WireType.Varint).int32(message.tacticalMastery);
        /* int32 improved_overpower = 7; */
        if (message.improvedOverpower !== 0)
            writer.tag(7, WireType.Varint).int32(message.improvedOverpower);
        /* bool anger_management = 8; */
        if (message.angerManagement !== false)
            writer.tag(8, WireType.Varint).bool(message.angerManagement);
        /* int32 impale = 9; */
        if (message.impale !== 0)
            writer.tag(9, WireType.Varint).int32(message.impale);
        /* int32 deep_wounds = 10; */
        if (message.deepWounds !== 0)
            writer.tag(10, WireType.Varint).int32(message.deepWounds);
        /* int32 two_handed_weapon_specialization = 11; */
        if (message.twoHandedWeaponSpecialization !== 0)
            writer.tag(11, WireType.Varint).int32(message.twoHandedWeaponSpecialization);
        /* int32 taste_for_blood = 12; */
        if (message.tasteForBlood !== 0)
            writer.tag(12, WireType.Varint).int32(message.tasteForBlood);
        /* int32 poleaxe_specialization = 13; */
        if (message.poleaxeSpecialization !== 0)
            writer.tag(13, WireType.Varint).int32(message.poleaxeSpecialization);
        /* bool sweeping_strikes = 14; */
        if (message.sweepingStrikes !== false)
            writer.tag(14, WireType.Varint).bool(message.sweepingStrikes);
        /* int32 mace_specialization = 15; */
        if (message.maceSpecialization !== 0)
            writer.tag(15, WireType.Varint).int32(message.maceSpecialization);
        /* int32 sword_specialization = 16; */
        if (message.swordSpecialization !== 0)
            writer.tag(16, WireType.Varint).int32(message.swordSpecialization);
        /* int32 weapon_mastery = 17; */
        if (message.weaponMastery !== 0)
            writer.tag(17, WireType.Varint).int32(message.weaponMastery);
        /* int32 improved_hamstring = 18; */
        if (message.improvedHamstring !== 0)
            writer.tag(18, WireType.Varint).int32(message.improvedHamstring);
        /* int32 trauma = 19; */
        if (message.trauma !== 0)
            writer.tag(19, WireType.Varint).int32(message.trauma);
        /* int32 second_wind = 20; */
        if (message.secondWind !== 0)
            writer.tag(20, WireType.Varint).int32(message.secondWind);
        /* bool mortal_strike = 21; */
        if (message.mortalStrike !== false)
            writer.tag(21, WireType.Varint).bool(message.mortalStrike);
        /* int32 strength_of_arms = 22; */
        if (message.strengthOfArms !== 0)
            writer.tag(22, WireType.Varint).int32(message.strengthOfArms);
        /* int32 improved_slam = 23; */
        if (message.improvedSlam !== 0)
            writer.tag(23, WireType.Varint).int32(message.improvedSlam);
        /* bool juggernaut = 24; */
        if (message.juggernaut !== false)
            writer.tag(24, WireType.Varint).bool(message.juggernaut);
        /* int32 improved_mortal_strike = 25; */
        if (message.improvedMortalStrike !== 0)
            writer.tag(25, WireType.Varint).int32(message.improvedMortalStrike);
        /* int32 unrelenting_assault = 26; */
        if (message.unrelentingAssault !== 0)
            writer.tag(26, WireType.Varint).int32(message.unrelentingAssault);
        /* int32 sudden_death = 27; */
        if (message.suddenDeath !== 0)
            writer.tag(27, WireType.Varint).int32(message.suddenDeath);
        /* bool endless_rage = 28; */
        if (message.endlessRage !== false)
            writer.tag(28, WireType.Varint).bool(message.endlessRage);
        /* int32 blood_frenzy = 29; */
        if (message.bloodFrenzy !== 0)
            writer.tag(29, WireType.Varint).int32(message.bloodFrenzy);
        /* int32 wrecking_crew = 30; */
        if (message.wreckingCrew !== 0)
            writer.tag(30, WireType.Varint).int32(message.wreckingCrew);
        /* bool bladestorm = 31; */
        if (message.bladestorm !== false)
            writer.tag(31, WireType.Varint).bool(message.bladestorm);
        /* int32 armored_to_the_teeth = 32; */
        if (message.armoredToTheTeeth !== 0)
            writer.tag(32, WireType.Varint).int32(message.armoredToTheTeeth);
        /* int32 booming_voice = 33; */
        if (message.boomingVoice !== 0)
            writer.tag(33, WireType.Varint).int32(message.boomingVoice);
        /* int32 cruelty = 34; */
        if (message.cruelty !== 0)
            writer.tag(34, WireType.Varint).int32(message.cruelty);
        /* int32 improved_demoralizing_shout = 35; */
        if (message.improvedDemoralizingShout !== 0)
            writer.tag(35, WireType.Varint).int32(message.improvedDemoralizingShout);
        /* int32 unbridled_wrath = 36; */
        if (message.unbridledWrath !== 0)
            writer.tag(36, WireType.Varint).int32(message.unbridledWrath);
        /* int32 improved_cleave = 37; */
        if (message.improvedCleave !== 0)
            writer.tag(37, WireType.Varint).int32(message.improvedCleave);
        /* bool piercing_howl = 38; */
        if (message.piercingHowl !== false)
            writer.tag(38, WireType.Varint).bool(message.piercingHowl);
        /* int32 blood_craze = 39; */
        if (message.bloodCraze !== 0)
            writer.tag(39, WireType.Varint).int32(message.bloodCraze);
        /* int32 commanding_presence = 40; */
        if (message.commandingPresence !== 0)
            writer.tag(40, WireType.Varint).int32(message.commandingPresence);
        /* int32 dual_wield_specialization = 41; */
        if (message.dualWieldSpecialization !== 0)
            writer.tag(41, WireType.Varint).int32(message.dualWieldSpecialization);
        /* int32 improved_execute = 42; */
        if (message.improvedExecute !== 0)
            writer.tag(42, WireType.Varint).int32(message.improvedExecute);
        /* int32 enrage = 43; */
        if (message.enrage !== 0)
            writer.tag(43, WireType.Varint).int32(message.enrage);
        /* int32 precision = 44; */
        if (message.precision !== 0)
            writer.tag(44, WireType.Varint).int32(message.precision);
        /* bool death_wish = 45; */
        if (message.deathWish !== false)
            writer.tag(45, WireType.Varint).bool(message.deathWish);
        /* int32 improved_intercept = 46; */
        if (message.improvedIntercept !== 0)
            writer.tag(46, WireType.Varint).int32(message.improvedIntercept);
        /* int32 improved_berserker_rage = 47; */
        if (message.improvedBerserkerRage !== 0)
            writer.tag(47, WireType.Varint).int32(message.improvedBerserkerRage);
        /* int32 flurry = 48; */
        if (message.flurry !== 0)
            writer.tag(48, WireType.Varint).int32(message.flurry);
        /* int32 intensify_rage = 49; */
        if (message.intensifyRage !== 0)
            writer.tag(49, WireType.Varint).int32(message.intensifyRage);
        /* bool bloodthirst = 50; */
        if (message.bloodthirst !== false)
            writer.tag(50, WireType.Varint).bool(message.bloodthirst);
        /* int32 improved_whirlwind = 51; */
        if (message.improvedWhirlwind !== 0)
            writer.tag(51, WireType.Varint).int32(message.improvedWhirlwind);
        /* int32 furious_attacks = 52; */
        if (message.furiousAttacks !== 0)
            writer.tag(52, WireType.Varint).int32(message.furiousAttacks);
        /* int32 improved_berserker_stance = 53; */
        if (message.improvedBerserkerStance !== 0)
            writer.tag(53, WireType.Varint).int32(message.improvedBerserkerStance);
        /* bool heroic_fury = 54; */
        if (message.heroicFury !== false)
            writer.tag(54, WireType.Varint).bool(message.heroicFury);
        /* bool rampage = 55; */
        if (message.rampage !== false)
            writer.tag(55, WireType.Varint).bool(message.rampage);
        /* int32 bloodsurge = 56; */
        if (message.bloodsurge !== 0)
            writer.tag(56, WireType.Varint).int32(message.bloodsurge);
        /* int32 unending_fury = 57; */
        if (message.unendingFury !== 0)
            writer.tag(57, WireType.Varint).int32(message.unendingFury);
        /* bool titans_grip = 58; */
        if (message.titansGrip !== false)
            writer.tag(58, WireType.Varint).bool(message.titansGrip);
        /* int32 improved_bloodrage = 59; */
        if (message.improvedBloodrage !== 0)
            writer.tag(59, WireType.Varint).int32(message.improvedBloodrage);
        /* int32 shield_specialization = 60; */
        if (message.shieldSpecialization !== 0)
            writer.tag(60, WireType.Varint).int32(message.shieldSpecialization);
        /* int32 improved_thunder_clap = 61; */
        if (message.improvedThunderClap !== 0)
            writer.tag(61, WireType.Varint).int32(message.improvedThunderClap);
        /* int32 incite = 62; */
        if (message.incite !== 0)
            writer.tag(62, WireType.Varint).int32(message.incite);
        /* int32 anticipation = 63; */
        if (message.anticipation !== 0)
            writer.tag(63, WireType.Varint).int32(message.anticipation);
        /* bool last_stand = 64; */
        if (message.lastStand !== false)
            writer.tag(64, WireType.Varint).bool(message.lastStand);
        /* int32 improved_revenge = 65; */
        if (message.improvedRevenge !== 0)
            writer.tag(65, WireType.Varint).int32(message.improvedRevenge);
        /* int32 shield_mastery = 66; */
        if (message.shieldMastery !== 0)
            writer.tag(66, WireType.Varint).int32(message.shieldMastery);
        /* int32 toughness = 67; */
        if (message.toughness !== 0)
            writer.tag(67, WireType.Varint).int32(message.toughness);
        /* int32 improved_spell_reflection = 68; */
        if (message.improvedSpellReflection !== 0)
            writer.tag(68, WireType.Varint).int32(message.improvedSpellReflection);
        /* int32 improved_disarm = 69; */
        if (message.improvedDisarm !== 0)
            writer.tag(69, WireType.Varint).int32(message.improvedDisarm);
        /* int32 puncture = 70; */
        if (message.puncture !== 0)
            writer.tag(70, WireType.Varint).int32(message.puncture);
        /* int32 improved_disciplines = 71; */
        if (message.improvedDisciplines !== 0)
            writer.tag(71, WireType.Varint).int32(message.improvedDisciplines);
        /* bool concussion_blow = 72; */
        if (message.concussionBlow !== false)
            writer.tag(72, WireType.Varint).bool(message.concussionBlow);
        /* int32 gag_order = 73; */
        if (message.gagOrder !== 0)
            writer.tag(73, WireType.Varint).int32(message.gagOrder);
        /* int32 one_handed_weapon_specialization = 74; */
        if (message.oneHandedWeaponSpecialization !== 0)
            writer.tag(74, WireType.Varint).int32(message.oneHandedWeaponSpecialization);
        /* int32 improved_defensive_stance = 75; */
        if (message.improvedDefensiveStance !== 0)
            writer.tag(75, WireType.Varint).int32(message.improvedDefensiveStance);
        /* bool vigilance = 76; */
        if (message.vigilance !== false)
            writer.tag(76, WireType.Varint).bool(message.vigilance);
        /* int32 focused_rage = 77; */
        if (message.focusedRage !== 0)
            writer.tag(77, WireType.Varint).int32(message.focusedRage);
        /* int32 vitality = 78; */
        if (message.vitality !== 0)
            writer.tag(78, WireType.Varint).int32(message.vitality);
        /* int32 safeguard = 79; */
        if (message.safeguard !== 0)
            writer.tag(79, WireType.Varint).int32(message.safeguard);
        /* bool warbringer = 80; */
        if (message.warbringer !== false)
            writer.tag(80, WireType.Varint).bool(message.warbringer);
        /* bool devastate = 81; */
        if (message.devastate !== false)
            writer.tag(81, WireType.Varint).bool(message.devastate);
        /* int32 critical_block = 82; */
        if (message.criticalBlock !== 0)
            writer.tag(82, WireType.Varint).int32(message.criticalBlock);
        /* int32 sword_and_board = 83; */
        if (message.swordAndBoard !== 0)
            writer.tag(83, WireType.Varint).int32(message.swordAndBoard);
        /* int32 damage_shield = 84; */
        if (message.damageShield !== 0)
            writer.tag(84, WireType.Varint).int32(message.damageShield);
        /* bool shockwave = 85; */
        if (message.shockwave !== false)
            writer.tag(85, WireType.Varint).bool(message.shockwave);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.WarriorTalents
 */
export const WarriorTalents = new WarriorTalents$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Warrior$Type extends MessageType<Warrior> {
    constructor() {
        super("proto.Warrior", [
            { no: 1, name: "rotation", kind: "message", T: () => Warrior_Rotation },
            { no: 3, name: "options", kind: "message", T: () => Warrior_Options }
        ]);
    }
    create(value?: PartialMessage<Warrior>): Warrior {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Warrior>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Warrior): Warrior {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.Warrior.Rotation rotation */ 1:
                    message.rotation = Warrior_Rotation.internalBinaryRead(reader, reader.uint32(), options, message.rotation);
                    break;
                case /* proto.Warrior.Options options */ 3:
                    message.options = Warrior_Options.internalBinaryRead(reader, reader.uint32(), options, message.options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Warrior, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.Warrior.Rotation rotation = 1; */
        if (message.rotation)
            Warrior_Rotation.internalBinaryWrite(message.rotation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.Warrior.Options options = 3; */
        if (message.options)
            Warrior_Options.internalBinaryWrite(message.options, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Warrior
 */
export const Warrior = new Warrior$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Warrior_Rotation$Type extends MessageType<Warrior_Rotation> {
    constructor() {
        super("proto.Warrior.Rotation", [
            { no: 1, name: "use_cleave", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "use_rend", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "use_ms", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "use_slam", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "main_gcd", kind: "enum", T: () => ["proto.Warrior.Rotation.MainGcd", Warrior_Rotation_MainGcd] },
            { no: 5, name: "sunderArmor", kind: "enum", T: () => ["proto.Warrior.Rotation.SunderArmor", Warrior_Rotation_SunderArmor] },
            { no: 6, name: "maintain_demo_shout", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "maintain_thunder_clap", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "hs_rage_threshold", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "ms_rage_threshold", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "rend_rage_threshold_below", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "slam_rage_threshold", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "rend_cd_threshold", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "use_hs_during_execute", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "use_bt_during_execute", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "spam_execute", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "use_ww_during_execute", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "use_slam_over_execute", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "stance_option", kind: "enum", T: () => ["proto.Warrior.Rotation.StanceOption", Warrior_Rotation_StanceOption] },
            { no: 20, name: "rend_health_threshold_above", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 21, name: "use_overpower", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "execute_phase_overpower", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "bloodsurge_duration_threshold", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 23, name: "custom_rotation", kind: "message", T: () => CustomRotation },
            { no: 24, name: "custom_rotation_option", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Warrior_Rotation>): Warrior_Rotation {
        const message = { useCleave: false, useRend: false, useMs: false, useSlam: false, mainGcd: 0, sunderArmor: 0, maintainDemoShout: false, maintainThunderClap: false, hsRageThreshold: 0, msRageThreshold: 0, rendRageThresholdBelow: 0, slamRageThreshold: 0, rendCdThreshold: 0, useHsDuringExecute: false, useBtDuringExecute: false, spamExecute: false, useWwDuringExecute: false, useSlamOverExecute: false, stanceOption: 0, rendHealthThresholdAbove: 0, useOverpower: false, executePhaseOverpower: false, bloodsurgeDurationThreshold: 0, customRotationOption: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Warrior_Rotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Warrior_Rotation): Warrior_Rotation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool use_cleave */ 1:
                    message.useCleave = reader.bool();
                    break;
                case /* bool use_rend */ 2:
                    message.useRend = reader.bool();
                    break;
                case /* bool use_ms */ 18:
                    message.useMs = reader.bool();
                    break;
                case /* bool use_slam */ 3:
                    message.useSlam = reader.bool();
                    break;
                case /* proto.Warrior.Rotation.MainGcd main_gcd */ 4:
                    message.mainGcd = reader.int32();
                    break;
                case /* proto.Warrior.Rotation.SunderArmor sunderArmor */ 5:
                    message.sunderArmor = reader.int32();
                    break;
                case /* bool maintain_demo_shout */ 6:
                    message.maintainDemoShout = reader.bool();
                    break;
                case /* bool maintain_thunder_clap */ 7:
                    message.maintainThunderClap = reader.bool();
                    break;
                case /* double hs_rage_threshold */ 8:
                    message.hsRageThreshold = reader.double();
                    break;
                case /* double ms_rage_threshold */ 9:
                    message.msRageThreshold = reader.double();
                    break;
                case /* double rend_rage_threshold_below */ 10:
                    message.rendRageThresholdBelow = reader.double();
                    break;
                case /* double slam_rage_threshold */ 11:
                    message.slamRageThreshold = reader.double();
                    break;
                case /* double rend_cd_threshold */ 12:
                    message.rendCdThreshold = reader.double();
                    break;
                case /* bool use_hs_during_execute */ 13:
                    message.useHsDuringExecute = reader.bool();
                    break;
                case /* bool use_bt_during_execute */ 14:
                    message.useBtDuringExecute = reader.bool();
                    break;
                case /* bool spam_execute */ 15:
                    message.spamExecute = reader.bool();
                    break;
                case /* bool use_ww_during_execute */ 16:
                    message.useWwDuringExecute = reader.bool();
                    break;
                case /* bool use_slam_over_execute */ 17:
                    message.useSlamOverExecute = reader.bool();
                    break;
                case /* proto.Warrior.Rotation.StanceOption stance_option */ 19:
                    message.stanceOption = reader.int32();
                    break;
                case /* double rend_health_threshold_above */ 20:
                    message.rendHealthThresholdAbove = reader.double();
                    break;
                case /* bool use_overpower */ 21:
                    message.useOverpower = reader.bool();
                    break;
                case /* bool execute_phase_overpower */ 22:
                    message.executePhaseOverpower = reader.bool();
                    break;
                case /* double bloodsurge_duration_threshold */ 25:
                    message.bloodsurgeDurationThreshold = reader.double();
                    break;
                case /* proto.CustomRotation custom_rotation */ 23:
                    message.customRotation = CustomRotation.internalBinaryRead(reader, reader.uint32(), options, message.customRotation);
                    break;
                case /* bool custom_rotation_option */ 24:
                    message.customRotationOption = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Warrior_Rotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool use_cleave = 1; */
        if (message.useCleave !== false)
            writer.tag(1, WireType.Varint).bool(message.useCleave);
        /* bool use_rend = 2; */
        if (message.useRend !== false)
            writer.tag(2, WireType.Varint).bool(message.useRend);
        /* bool use_ms = 18; */
        if (message.useMs !== false)
            writer.tag(18, WireType.Varint).bool(message.useMs);
        /* bool use_slam = 3; */
        if (message.useSlam !== false)
            writer.tag(3, WireType.Varint).bool(message.useSlam);
        /* proto.Warrior.Rotation.MainGcd main_gcd = 4; */
        if (message.mainGcd !== 0)
            writer.tag(4, WireType.Varint).int32(message.mainGcd);
        /* proto.Warrior.Rotation.SunderArmor sunderArmor = 5; */
        if (message.sunderArmor !== 0)
            writer.tag(5, WireType.Varint).int32(message.sunderArmor);
        /* bool maintain_demo_shout = 6; */
        if (message.maintainDemoShout !== false)
            writer.tag(6, WireType.Varint).bool(message.maintainDemoShout);
        /* bool maintain_thunder_clap = 7; */
        if (message.maintainThunderClap !== false)
            writer.tag(7, WireType.Varint).bool(message.maintainThunderClap);
        /* double hs_rage_threshold = 8; */
        if (message.hsRageThreshold !== 0)
            writer.tag(8, WireType.Bit64).double(message.hsRageThreshold);
        /* double ms_rage_threshold = 9; */
        if (message.msRageThreshold !== 0)
            writer.tag(9, WireType.Bit64).double(message.msRageThreshold);
        /* double rend_rage_threshold_below = 10; */
        if (message.rendRageThresholdBelow !== 0)
            writer.tag(10, WireType.Bit64).double(message.rendRageThresholdBelow);
        /* double slam_rage_threshold = 11; */
        if (message.slamRageThreshold !== 0)
            writer.tag(11, WireType.Bit64).double(message.slamRageThreshold);
        /* double rend_cd_threshold = 12; */
        if (message.rendCdThreshold !== 0)
            writer.tag(12, WireType.Bit64).double(message.rendCdThreshold);
        /* bool use_hs_during_execute = 13; */
        if (message.useHsDuringExecute !== false)
            writer.tag(13, WireType.Varint).bool(message.useHsDuringExecute);
        /* bool use_bt_during_execute = 14; */
        if (message.useBtDuringExecute !== false)
            writer.tag(14, WireType.Varint).bool(message.useBtDuringExecute);
        /* bool spam_execute = 15; */
        if (message.spamExecute !== false)
            writer.tag(15, WireType.Varint).bool(message.spamExecute);
        /* bool use_ww_during_execute = 16; */
        if (message.useWwDuringExecute !== false)
            writer.tag(16, WireType.Varint).bool(message.useWwDuringExecute);
        /* bool use_slam_over_execute = 17; */
        if (message.useSlamOverExecute !== false)
            writer.tag(17, WireType.Varint).bool(message.useSlamOverExecute);
        /* proto.Warrior.Rotation.StanceOption stance_option = 19; */
        if (message.stanceOption !== 0)
            writer.tag(19, WireType.Varint).int32(message.stanceOption);
        /* double rend_health_threshold_above = 20; */
        if (message.rendHealthThresholdAbove !== 0)
            writer.tag(20, WireType.Bit64).double(message.rendHealthThresholdAbove);
        /* bool use_overpower = 21; */
        if (message.useOverpower !== false)
            writer.tag(21, WireType.Varint).bool(message.useOverpower);
        /* bool execute_phase_overpower = 22; */
        if (message.executePhaseOverpower !== false)
            writer.tag(22, WireType.Varint).bool(message.executePhaseOverpower);
        /* double bloodsurge_duration_threshold = 25; */
        if (message.bloodsurgeDurationThreshold !== 0)
            writer.tag(25, WireType.Bit64).double(message.bloodsurgeDurationThreshold);
        /* proto.CustomRotation custom_rotation = 23; */
        if (message.customRotation)
            CustomRotation.internalBinaryWrite(message.customRotation, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* bool custom_rotation_option = 24; */
        if (message.customRotationOption !== false)
            writer.tag(24, WireType.Varint).bool(message.customRotationOption);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Warrior.Rotation
 */
export const Warrior_Rotation = new Warrior_Rotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Warrior_Options$Type extends MessageType<Warrior_Options> {
    constructor() {
        super("proto.Warrior.Options", [
            { no: 1, name: "starting_rage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "use_recklessness", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "use_shattering_throw", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "shout", kind: "enum", T: () => ["proto.WarriorShout", WarriorShout] },
            { no: 5, name: "munch", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "stance_snapshot", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Warrior_Options>): Warrior_Options {
        const message = { startingRage: 0, useRecklessness: false, useShatteringThrow: false, shout: 0, munch: false, stanceSnapshot: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Warrior_Options>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Warrior_Options): Warrior_Options {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double starting_rage */ 1:
                    message.startingRage = reader.double();
                    break;
                case /* bool use_recklessness */ 2:
                    message.useRecklessness = reader.bool();
                    break;
                case /* bool use_shattering_throw */ 4:
                    message.useShatteringThrow = reader.bool();
                    break;
                case /* proto.WarriorShout shout */ 3:
                    message.shout = reader.int32();
                    break;
                case /* bool munch */ 5:
                    message.munch = reader.bool();
                    break;
                case /* bool stance_snapshot */ 6:
                    message.stanceSnapshot = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Warrior_Options, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double starting_rage = 1; */
        if (message.startingRage !== 0)
            writer.tag(1, WireType.Bit64).double(message.startingRage);
        /* bool use_recklessness = 2; */
        if (message.useRecklessness !== false)
            writer.tag(2, WireType.Varint).bool(message.useRecklessness);
        /* bool use_shattering_throw = 4; */
        if (message.useShatteringThrow !== false)
            writer.tag(4, WireType.Varint).bool(message.useShatteringThrow);
        /* proto.WarriorShout shout = 3; */
        if (message.shout !== 0)
            writer.tag(3, WireType.Varint).int32(message.shout);
        /* bool munch = 5; */
        if (message.munch !== false)
            writer.tag(5, WireType.Varint).bool(message.munch);
        /* bool stance_snapshot = 6; */
        if (message.stanceSnapshot !== false)
            writer.tag(6, WireType.Varint).bool(message.stanceSnapshot);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Warrior.Options
 */
export const Warrior_Options = new Warrior_Options$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProtectionWarrior$Type extends MessageType<ProtectionWarrior> {
    constructor() {
        super("proto.ProtectionWarrior", [
            { no: 1, name: "rotation", kind: "message", T: () => ProtectionWarrior_Rotation },
            { no: 3, name: "options", kind: "message", T: () => ProtectionWarrior_Options }
        ]);
    }
    create(value?: PartialMessage<ProtectionWarrior>): ProtectionWarrior {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProtectionWarrior>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProtectionWarrior): ProtectionWarrior {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ProtectionWarrior.Rotation rotation */ 1:
                    message.rotation = ProtectionWarrior_Rotation.internalBinaryRead(reader, reader.uint32(), options, message.rotation);
                    break;
                case /* proto.ProtectionWarrior.Options options */ 3:
                    message.options = ProtectionWarrior_Options.internalBinaryRead(reader, reader.uint32(), options, message.options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProtectionWarrior, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ProtectionWarrior.Rotation rotation = 1; */
        if (message.rotation)
            ProtectionWarrior_Rotation.internalBinaryWrite(message.rotation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.ProtectionWarrior.Options options = 3; */
        if (message.options)
            ProtectionWarrior_Options.internalBinaryWrite(message.options, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.ProtectionWarrior
 */
export const ProtectionWarrior = new ProtectionWarrior$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProtectionWarrior_Rotation$Type extends MessageType<ProtectionWarrior_Rotation> {
    constructor() {
        super("proto.ProtectionWarrior.Rotation", [
            { no: 1, name: "demo_shout_choice", kind: "enum", T: () => ["proto.ProtectionWarrior.Rotation.DemoShoutChoice", ProtectionWarrior_Rotation_DemoShoutChoice] },
            { no: 2, name: "thunder_clap_choice", kind: "enum", T: () => ["proto.ProtectionWarrior.Rotation.ThunderClapChoice", ProtectionWarrior_Rotation_ThunderClapChoice] },
            { no: 3, name: "custom_rotation", kind: "message", T: () => CustomRotation },
            { no: 4, name: "hs_rage_threshold", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "prio_sslam_on_shield_block", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ProtectionWarrior_Rotation>): ProtectionWarrior_Rotation {
        const message = { demoShoutChoice: 0, thunderClapChoice: 0, hsRageThreshold: 0, prioSslamOnShieldBlock: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProtectionWarrior_Rotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProtectionWarrior_Rotation): ProtectionWarrior_Rotation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.ProtectionWarrior.Rotation.DemoShoutChoice demo_shout_choice */ 1:
                    message.demoShoutChoice = reader.int32();
                    break;
                case /* proto.ProtectionWarrior.Rotation.ThunderClapChoice thunder_clap_choice */ 2:
                    message.thunderClapChoice = reader.int32();
                    break;
                case /* proto.CustomRotation custom_rotation */ 3:
                    message.customRotation = CustomRotation.internalBinaryRead(reader, reader.uint32(), options, message.customRotation);
                    break;
                case /* double hs_rage_threshold */ 4:
                    message.hsRageThreshold = reader.double();
                    break;
                case /* bool prio_sslam_on_shield_block */ 5:
                    message.prioSslamOnShieldBlock = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProtectionWarrior_Rotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.ProtectionWarrior.Rotation.DemoShoutChoice demo_shout_choice = 1; */
        if (message.demoShoutChoice !== 0)
            writer.tag(1, WireType.Varint).int32(message.demoShoutChoice);
        /* proto.ProtectionWarrior.Rotation.ThunderClapChoice thunder_clap_choice = 2; */
        if (message.thunderClapChoice !== 0)
            writer.tag(2, WireType.Varint).int32(message.thunderClapChoice);
        /* proto.CustomRotation custom_rotation = 3; */
        if (message.customRotation)
            CustomRotation.internalBinaryWrite(message.customRotation, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* double hs_rage_threshold = 4; */
        if (message.hsRageThreshold !== 0)
            writer.tag(4, WireType.Bit64).double(message.hsRageThreshold);
        /* bool prio_sslam_on_shield_block = 5; */
        if (message.prioSslamOnShieldBlock !== false)
            writer.tag(5, WireType.Varint).bool(message.prioSslamOnShieldBlock);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.ProtectionWarrior.Rotation
 */
export const ProtectionWarrior_Rotation = new ProtectionWarrior_Rotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProtectionWarrior_Options$Type extends MessageType<ProtectionWarrior_Options> {
    constructor() {
        super("proto.ProtectionWarrior.Options", [
            { no: 1, name: "starting_rage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "shout", kind: "enum", T: () => ["proto.WarriorShout", WarriorShout] },
            { no: 8, name: "use_shattering_throw", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "munch", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ProtectionWarrior_Options>): ProtectionWarrior_Options {
        const message = { startingRage: 0, shout: 0, useShatteringThrow: false, munch: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProtectionWarrior_Options>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProtectionWarrior_Options): ProtectionWarrior_Options {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double starting_rage */ 1:
                    message.startingRage = reader.double();
                    break;
                case /* proto.WarriorShout shout */ 4:
                    message.shout = reader.int32();
                    break;
                case /* bool use_shattering_throw */ 8:
                    message.useShatteringThrow = reader.bool();
                    break;
                case /* bool munch */ 9:
                    message.munch = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProtectionWarrior_Options, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double starting_rage = 1; */
        if (message.startingRage !== 0)
            writer.tag(1, WireType.Bit64).double(message.startingRage);
        /* proto.WarriorShout shout = 4; */
        if (message.shout !== 0)
            writer.tag(4, WireType.Varint).int32(message.shout);
        /* bool use_shattering_throw = 8; */
        if (message.useShatteringThrow !== false)
            writer.tag(8, WireType.Varint).bool(message.useShatteringThrow);
        /* bool munch = 9; */
        if (message.munch !== false)
            writer.tag(9, WireType.Varint).bool(message.munch);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.ProtectionWarrior.Options
 */
export const ProtectionWarrior_Options = new ProtectionWarrior_Options$Type();
